<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="600px">
    <div v-loading="!ready" style="height: 340px; width: 360px; margin: 20px 80px">
      <el-form v-if="ready" label-position="right" label-width="100px" :model="procedure" :rules="rules"
               ref="procedure">

        <input-form-item label="工序名称" prop="name"></input-form-item>

        <remote-form-item label="工序类型" prop="type" class-name="MiddleProcedureType"></remote-form-item>

        <remote-form-item label="基础工序设置" prop="basicTypes" class-name="BASIC_PROCEDURE_TYPE"
                          using-code></remote-form-item>

        <input-form-item label="标准工时" prop="workHourMin" suffix="分钟"></input-form-item>

        <status-form-item label="状态"></status-form-item>

        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()" :disabled="!ready">新 增</el-button>
      <el-button v-else type="primary" @click="save()" :disabled="!ready">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { Procedure } from '@/store/objdef/objectDef'
  import InputFormItem from '@/components/form/InputFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'

  export default {
    name: 'EditProcedureDialog',
    components: {
      TextareaFormItem,
      StatusFormItem,
      RemoteFormItem,
      InputFormItem
    },
    props: {
      procedureId: Number,
      readOnly: Boolean
    },
    data () {
      return {
        procedure: new Procedure(),
        loaded: false,
        rules: {
          name: [
            {
              required: true,
              message: '请输入名称',
              trigger: 'blur'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择工序类型',
              trigger: 'blur'
            }
          ],
          workHourMin: [
            {
              required: true,
              message: '请输入标准工时',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      open () {
        if (!this.isNew) {
          this.$store.dispatch('procedure/procedureById', this.procedureId).then(procedure => {
            this.procedure = procedure
            this.loaded = true
          })
        }
      },
      closed () {
        this.procedure = new Procedure()
        this.loaded = false
        this.$refs.procedure.resetFields()
      },
      add () {
        this.$refs.procedure.validate(valid => {
          if (!valid) return

          this.$store.dispatch('procedure/add', this.procedure).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.procedure.validate(valid => {
          if (!valid) return

          this.$store.dispatch('procedure/updateOne', this.procedure).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.procedureId
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增施工序'
        return this.readOnly ? '查看施工序' : '编辑施工序'
      },
      ready () {
        return this.isNew || this.loaded
      }
    }
  }
</script>

<style scoped>

</style>
